import React, { useState } from "react";
import {
	Box,
	Button,
	TextField,
	Typography,
	CircularProgress,
} from "@mui/material";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import {
	Elements,
	useStripe,
	useElements,
	CardElement,
} from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function DepositForm() {
	const [amount, setAmount] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [notes, setNotes] = useState("");
	const [loading, setLoading] = useState(false);
	const [clientSecret, setClientSecret] = useState(null);
	const [orderNumber, setOrderNumber] = useState(null);
	const [error, setError] = useState("");
	const stripe = useStripe();
	const elements = useElements();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setLoading(true);

		try {
			// 1. Create payment intent and deposit record
			const response = await axios.post(
				`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/create-deposit-session`,
				{ amount: parseFloat(amount), email, phone, notes },
				{
					headers: {
						Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
					},
				}
			);
			setClientSecret(response.data.client_secret);
			setOrderNumber(response.data.order_number);
		} catch (err) {
			setError(
				"Failed to create payment: " +
					(err.response?.data?.error || err.message)
			);
		}
		setLoading(false);
	};

	const handleStripePayment = async (e) => {
		e.preventDefault();
		setError("");
		setLoading(true);

		const cardElement = elements.getElement(CardElement);
		const { error: stripeError, paymentIntent } =
			await stripe.confirmCardPayment(clientSecret, {
				payment_method: {
					card: cardElement,
					billing_details: { email, phone },
				},
			});

		if (stripeError) {
			setError(stripeError.message);
		} else if (paymentIntent.status === "succeeded") {
			setError("");
			// Payment succeeded
			//redirect to success page or show success message
			window.location.href = `/deposit-success?order_number=${orderNumber}`;
			// Optionally show a success message or redirect
		}
		setLoading(false);
	};

	if (clientSecret) {
		// Show Stripe Card form
		return (
			<Box>
				<Typography variant="h5" mb={2}>
					Pay Deposit
				</Typography>
				<form onSubmit={handleStripePayment}>
					<CardElement />
					<Button
						type="submit"
						variant="contained"
						fullWidth
						disabled={loading}
					>
						{loading ? <CircularProgress size={24} /> : "Pay"}
					</Button>
				</form>
				{orderNumber && (
					<Typography mt={2}>
						Your Order Number: <b>{orderNumber}</b>
					</Typography>
				)}
				{error && <Typography color="error">{error}</Typography>}
			</Box>
		);
	}

	// Initial form
	return (
		<Box>
			<Typography variant="h4" mb={2}>
				Make a Deposit
			</Typography>
			<form onSubmit={handleSubmit}>
				<TextField
					label="Deposit Amount (USD)"
					type="number"
					value={amount}
					onChange={(e) => setAmount(e.target.value)}
					required
					fullWidth
					sx={{ mb: 2 }}
				/>
				<TextField
					label="Email"
					type="email"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					required
					fullWidth
					sx={{ mb: 2 }}
				/>
				<TextField
					label="Phone"
					value={phone}
					onChange={(e) => setPhone(e.target.value)}
					fullWidth
					sx={{ mb: 2 }}
				/>
				<TextField
					label="Order Notes"
					value={notes}
					onChange={(e) => setNotes(e.target.value)}
					fullWidth
					sx={{ mb: 2 }}
				/>
				<Button type="submit" variant="contained" fullWidth disabled={loading}>
					{loading ? <CircularProgress size={24} /> : "Continue to Payment"}
				</Button>
			</form>
			{error && <Typography color="error">{error}</Typography>}
		</Box>
	);
}

const PayDeposit = () => (
	<Elements stripe={stripePromise}>
		<DepositForm />
	</Elements>
);

export default PayDeposit;
